import React from "react";
import Search from "@ingka/search";
import Grid from "../components/layout/GridLayout";
import Select, { Option } from "@ingka/select";
import styled from "styled-components";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const StyledSelect = styled(Select)`
	width: 90%;
	max-width: ${props => props.maxwidth || "500px"};
	margin-left: 30px;
	margin-bottom: 40px;
`;

const OrderSearchView = ({ onChange, onSearch, onClearSearch, value, onSearchCountryChange }) => {
	const { selectedSearchCountry, searchCountries } = useSelector(state => state.orderCorrectionController);

	return (
		<>
			{searchCountries && searchCountries.length > 1 && (
				<StyledSelect
					id="searchCountries"
					label={"Country order belongs to"}
					onChange={(e, isHintSelected) => {
						onSearchCountryChange({
							code: e.target.options[e.target.selectedIndex].value,
							name: e.target.options[e.target.selectedIndex].text,
							isDummy: isHintSelected
						});
					}}
					value={selectedSearchCountry.code}
				>
					{searchCountries
						.slice()
						.sort((a, b) => {
							const countryNameA = a.countryName.toUpperCase();
							const countryNameB = b.countryName.toUpperCase();
							if (countryNameA < countryNameB) {
								return -1;
							}
							if (countryNameA > countryNameB) {
								return 1;
							}
							return 0;
						})
						.map(country => (
							<Option key={country.countryCode} value={country.countryCode} name={country.countryName} />
						))}
				</StyledSelect>
			)}

			<Grid justifyContent={"space-between"} width={"auto"} marginleft={"30px"}>
				<Search
					id="orderSearch"
					value={value}
					placeholder="Order Number"
					onChange={onChange}
					onClear={onClearSearch}
					onSearch={onSearch}
					disabled={searchCountries.length > 1 && selectedSearchCountry.isDummy}
				/>
			</Grid>
		</>
	);
};

OrderSearchView.propTypes = {
	onChange: PropTypes.func.isRequired,
	onClearSearch: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired,
	onSearchCountryChange: PropTypes.func.isRequired
};

export default OrderSearchView;
